import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ClosingCostsByState from "@/pages/ClosingCostsByState";

export const Route = createFileRoute("/closing-costs/$state")({
  head: ({ params }) => seoHead(`/closing-costs/${params.state}`),
  component: ClosingCostsByState,
});
